import { render, staticRenderFns } from "./AtePlatTestingExamStat.vue?vue&type=template&id=4a5a12c4"
import script from "./AtePlatTestingExamStat.vue?vue&type=script&lang=js"
export * from "./AtePlatTestingExamStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports